module.exports = __webpack_public_path__ + "img/icon_arrow_down_2.a18b91ca.svg";